import './styles/global.css';
import '@pgcustom/design-system';
import { injetarTokensGlobais } from '@pgcustom/design-system';
import './core/app-shell/erp-shell.js';
import './modules/auth/login.page.js';
import './modules/auth/trocar-senha-obrigatoria.page.js';
import './modules/dashboard/dashboard.page.js';
import './modules/dashboard-ceo/dashboard-ceo.page.js';
import './modules/dashboard-colaborador/dashboard-colaborador.page.js';
import './modules/dashboard-tecnico/dashboard-tecnico.page.js';
import './modules/dashboard-socio/dashboard-socio.page.js';
import './modules/clientes/clientes.page.js';
import './modules/pedidos/pedidos.page.js';
import './modules/financeiro/financeiro.page.js';
import './modules/faturamento/faturamento.page.js';
import './modules/caixa-banco/caixa-banco.page.js';
import './modules/producao/producao.page.js';
import './modules/parceiros/parceiros.page.js';
import './modules/estoque/estoque.page.js';
import './modules/envios/envios.page.js';
import './modules/garantias/garantias.page.js';
import './modules/bonus-pg/bonus-pg.page.js';
import './modules/suporte/suporte.page.js';
import './modules/cms/cms.page.js';
import './modules/galeria/galeria.page.js';
import './modules/automacoes/automacoes.page.js';
import './modules/integracoes/melhor-envio.page.js';
import './modules/usuarios/usuarios.page.js';
import './modules/equipe/equipe.page.js';
import './modules/auditoria/auditoria.page.js';
import './modules/papeis-permissoes/papeis-permissoes.page.js';
import './modules/parceiro-portal/portal-login.page.js';
import './modules/parceiro-portal/portal-parceiro.page.js';
import './modules/parceiro-portal/portal-trocar-senha-obrigatoria.page.js';
import './modules/cliente-portal/portal-login.page.js';
import './modules/cliente-portal/portal-cliente.page.js';
import { ApiClient } from './core/api-client.js';
import { sessionStore } from './core/session.js';
import type { UsuarioSessao } from './core/session.js';
import { Router } from './core/router.js';
import type { Rota } from './core/router.js';
import { GRUPOS_NAVEGACAO } from './core/app-shell/navegacao.js';
import { criarPaginaModuloIndisponivel } from './core/pages/modulo-indisponivel.page.js';
import { criarPaginaNaoEncontrada } from './core/pages/nao-encontrada.page.js';
import { AuthApi } from './modules/auth/auth.api.js';
import { DashboardApi } from './modules/dashboard/dashboard.api.js';
import { ClientesApi } from './modules/clientes/clientes.api.js';
import { permissoesClientes } from './modules/clientes/clientes.permissoes.js';
import { PedidosApi } from './modules/pedidos/pedidos.api.js';
import { permissoesPedidos } from './modules/pedidos/pedidos.permissoes.js';
import { FinanceiroApi } from './modules/financeiro/financeiro.api.js';
import { permissoesFinanceiro } from './modules/financeiro/financeiro.permissoes.js';
import { FaturamentoApi } from './modules/faturamento/faturamento.api.js';
import { permissoesFaturamento } from './modules/faturamento/faturamento.permissoes.js';
import { CaixaBancoApi } from './modules/caixa-banco/caixa-banco.api.js';
import { OpsApi } from './modules/producao/ops.api.js';
import { permissoesOps } from './modules/producao/ops.permissoes.js';
import { ParceirosApi } from './modules/parceiros/parceiros.api.js';
import { permissoesParceiros } from './modules/parceiros/parceiros.permissoes.js';
import { ComissoesApi } from './modules/comissoes/comissoes.api.js';
import { permissoesComissoes } from './modules/comissoes/comissoes.permissoes.js';
import { EstoqueApi } from './modules/estoque/estoque.api.js';
import { permissoesEstoque } from './modules/estoque/estoque.permissoes.js';
import { EnviosApi } from './modules/envios/envios.api.js';
import { permissoesEnvios } from './modules/envios/envios.permissoes.js';
import { GarantiasApi } from './modules/garantias/garantias.api.js';
import { permissoesGarantias } from './modules/garantias/garantias.permissoes.js';
import { SuporteApi } from './modules/suporte/suporte.api.js';
import { permissoesSuporte } from './modules/suporte/suporte.permissoes.js';
import { CmsApi } from './modules/cms/cms.api.js';
import { permissoesCms } from './modules/cms/cms.permissoes.js';
import { GaleriaApi } from './modules/galeria/galeria.api.js';
import { permissoesGaleria } from './modules/galeria/galeria.permissoes.js';
import { AutomacoesApi } from './modules/automacoes/automacoes.api.js';
import { permissoesAutomacoes } from './modules/automacoes/automacoes.permissoes.js';
import { IntegracoesApi } from './modules/integracoes/integracoes.api.js';
import { permissoesIntegracoes } from './modules/integracoes/integracoes.permissoes.js';
import { UsuariosApi } from './modules/usuarios/usuarios.api.js';
import { permissoesUsuarios } from './modules/usuarios/usuarios.permissoes.js';
import { permissoesEquipe } from './modules/equipe/equipe.permissoes.js';
import { AuditoriaApi } from './modules/auditoria/auditoria.api.js';
import { permissoesAuditoria } from './modules/auditoria/auditoria.permissoes.js';
import { PapeisPermissoesApi } from './modules/papeis-permissoes/papeis-permissoes.api.js';
import { permissoesPapeisPermissoes } from './modules/papeis-permissoes/papeis-permissoes.permissoes.js';
import { NotificacoesApi } from './modules/notificacoes/notificacoes.api.js';
import { RelatoriosApi } from './modules/relatorios/relatorios.api.js';
import { permissoesRelatorios } from './modules/relatorios/relatorios.permissoes.js';
import { SocietarioApi } from './modules/societario/societario.api.js';
import { permissoesBonusPg } from './modules/bonus-pg/bonus-pg.permissoes.js';
import { PortalParceiroApi } from './modules/parceiro-portal/portal-parceiro.api.js';
import { portalParceiroSessionStore } from './modules/parceiro-portal/portal-parceiro.session.js';
import { PortalClienteApi } from './modules/cliente-portal/portal-cliente.api.js';
import { portalClienteSessionStore } from './modules/cliente-portal/portal-cliente.session.js';
import { logger } from './core/logger.js';

injetarTokensGlobais();

const CAMINHO_LOGIN = '/login';
const CAMINHO_TROCAR_SENHA_OBRIGATORIA = '/trocar-senha-obrigatoria';
const CAMINHO_INICIAL = '/dashboard';
const CAMINHO_MINHA_PARTICIPACAO = '/minha-participacao';
const CAMINHO_CLIENTES = '/clientes';
const CAMINHO_PEDIDOS = '/pedidos';
const CAMINHO_FINANCEIRO = '/financeiro';
const CAMINHO_FATURAMENTO = '/financeiro/faturamento';
const CAMINHO_CAIXA_BANCO = '/financeiro/caixa-banco';
const CAMINHO_PRODUCAO = '/producao';
const CAMINHO_PARCERIAS = '/parcerias';
const CAMINHO_ESTOQUE = '/estoque';
const CAMINHO_ENVIOS = '/envios';
const CAMINHO_GARANTIAS = '/garantias';
const CAMINHO_BONUS_PG = '/bonus-pg';
const CAMINHO_SUPORTE = '/suporte';
const CAMINHO_CMS = '/cms';
const CAMINHO_GALERIA = '/galeria';
const CAMINHO_AUTOMACOES = '/automacoes';
const CAMINHO_INTEGRACOES_MELHOR_ENVIO = '/integracoes/melhor-envio';
const CAMINHO_EQUIPE = '/admin/equipe';
const CAMINHO_USUARIOS = '/admin/usuarios';
const CAMINHO_PERMISSOES = '/admin/permissoes';
const CAMINHO_AUDITORIA = '/admin/auditoria';
const CAMINHO_PORTAL_PARCEIRO_LOGIN = '/portal-parceiro/login';
const CAMINHO_PORTAL_PARCEIRO = '/portal-parceiro';
const CAMINHO_PORTAL_PARCEIRO_TROCAR_SENHA = '/portal-parceiro/trocar-senha-obrigatoria';
const CAMINHO_PORTAL_CLIENTE_LOGIN = '/portal-cliente/login';
const CAMINHO_PORTAL_CLIENTE = '/portal-cliente';

const appEl = document.getElementById('app');
if (!appEl) {
  throw new Error('elemento #app não encontrado em index.html');
}

/**
 * O shell (sidebar + header) é criado uma única vez e reaproveitado
 * entre navegações — mas só é anexado ao `#app` para rotas autenticadas
 * (`paginaAutenticada`). A tela de login nunca deve mostrar navegação
 * do ERP antes de existir sessão; por isso o roteador troca o conteúdo
 * de `#app` inteiro, não apenas o interior do shell.
 */
const shell = document.createElement('erp-shell');

/**
 * Guarda central de troca de senha obrigatória: toda rota autenticada
 * passa por aqui, então este é o único ponto necessário para impedir
 * acesso ao resto do ERP enquanto `deveTrocarSenha` for `true` — mesmo
 * princípio do bloqueio real no backend (`authorization.middleware.ts`),
 * esta é só a camada de UX, nunca a garantia de segurança em si.
 */
function paginaAutenticada(criarConteudo: () => HTMLElement): HTMLElement {
  if (sessionStore.obterUsuario()?.deveTrocarSenha) {
    router.navegar(CAMINHO_TROCAR_SENHA_OBRIGATORIA);
    shell.outlet.replaceChildren(document.createElement('div'));
    return shell;
  }
  shell.outlet.replaceChildren(criarConteudo());
  return shell;
}

const api = new ApiClient({
  onNaoAutorizado: () => {
    if (!sessionStore.estaAutenticado()) return;
    sessionStore.definirUsuario(null);
    router.navegar(CAMINHO_LOGIN);
  },
});

/**
 * `ApiClient` própria do Portal do Parceiro — nunca a mesma instância
 * `api` do ERP interno. Um 401 aqui (sessão de parceiro expirada) só
 * deve derrubar `portalParceiroSessionStore` e mandar para o login do
 * Portal, nunca mexer em `sessionStore` (Auth interno) nem redirecionar
 * para `/login`. Mesma fronteira de identidade já aplicada no backend
 * (`parceiros-portal` nunca compartilha middleware com `auth`).
 */
const apiPortalParceiro = new ApiClient({
  onNaoAutorizado: () => {
    if (!portalParceiroSessionStore.estaAutenticado()) return;
    portalParceiroSessionStore.definirParceiro(null);
    router.navegar(CAMINHO_PORTAL_PARCEIRO_LOGIN);
  },
});

/**
 * `ApiClient` própria do Portal do Cliente — nunca a mesma instância
 * `api` do ERP interno, nem `apiPortalParceiro`. Um 401 aqui (sessão de
 * cliente expirada) só deve derrubar `portalClienteSessionStore` e
 * mandar para o login do Portal do Cliente, nunca mexer nas outras duas
 * sessões (mesma fronteira de identidade já aplicada no backend —
 * `cliente-portal` nunca compartilha middleware com `auth`/`parceiros-portal`).
 */
const apiPortalCliente = new ApiClient({
  onNaoAutorizado: () => {
    if (!portalClienteSessionStore.estaAutenticado()) return;
    portalClienteSessionStore.definirCliente(null);
    router.navegar(CAMINHO_PORTAL_CLIENTE_LOGIN);
  },
});

const authApi = new AuthApi(api);
const clientesApi = new ClientesApi(api);
const pedidosApi = new PedidosApi(api);
const financeiroApi = new FinanceiroApi(api);
const faturamentoApi = new FaturamentoApi(api);
const caixaBancoApi = new CaixaBancoApi(api);
const opsApi = new OpsApi(api);
const parceirosApi = new ParceirosApi(api);
const comissoesApi = new ComissoesApi(api);
const estoqueApi = new EstoqueApi(api);
const enviosApi = new EnviosApi(api);
const garantiasApi = new GarantiasApi(api);
const suporteApi = new SuporteApi(api);
const cmsApi = new CmsApi(api);
const galeriaApi = new GaleriaApi(api);
const automacoesApi = new AutomacoesApi(api);
const integracoesApi = new IntegracoesApi(api);
const usuariosApi = new UsuariosApi(api);
const auditoriaApi = new AuditoriaApi(api);
const papeisPermissoesApi = new PapeisPermissoesApi(api);
const notificacoesApi = new NotificacoesApi(api);
const relatoriosApi = new RelatoriosApi(api);
const societarioApi = new SocietarioApi(api);
const dashboardApi = new DashboardApi(api, pedidosApi, financeiroApi, opsApi, estoqueApi, suporteApi);
const portalParceiroApi = new PortalParceiroApi(apiPortalParceiro);
const portalClienteApi = new PortalClienteApi(apiPortalCliente);

async function aoSair(): Promise<void> {
  try {
    await authApi.logout();
  } catch (erro) {
    logger.erro('falha ao encerrar sessão no servidor', { erro });
  } finally {
    sessionStore.definirUsuario(null);
    router.navegar(CAMINHO_LOGIN);
  }
}

shell.sidebar.grupos = GRUPOS_NAVEGACAO;
// `erp-navegar` (composed) borbulha da sidebar, do header E do conteúdo do
// outlet (ex.: atalhos do Financeiro, "Ver pedido" do Faturamento) — um
// único listener no shell cobre os três.
shell.addEventListener('erp-navegar', (evento) => {
  const { caminho } = (evento as CustomEvent<{ caminho: string }>).detail;
  router.navegar(caminho);
});
shell.header.addEventListener('erp-sair', () => void aoSair());
shell.header.addEventListener('erp-notificacao-lida', (evento) => {
  const { id } = (evento as CustomEvent<{ id: string }>).detail;
  void marcarNotificacaoComoLida(id);
});

const INTERVALO_ATUALIZACAO_NOTIFICACOES_MS = 60_000;

async function atualizarNotificacoes(): Promise<void> {
  if (!sessionStore.estaAutenticado()) {
    shell.header.notificacoes = [];
    return;
  }
  shell.header.notificacoes = await notificacoesApi.listar();
}

async function marcarNotificacaoComoLida(id: string): Promise<void> {
  try {
    await notificacoesApi.marcarComoLida(id);
  } catch (erro) {
    logger.erro('falha ao marcar notificação como lida', { erro });
  }
  await atualizarNotificacoes();
}

function tituloDaRota(caminho: string): string {
  for (const grupo of GRUPOS_NAVEGACAO) {
    const item = grupo.itens.find((i) => i.caminho === caminho);
    if (item) return item.rotulo;
  }
  return 'PG Custom ERP';
}

const rotaLogin: Rota = {
  caminho: CAMINHO_LOGIN,
  publica: true,
  renderizar: () => {
    const pagina = document.createElement('erp-login-page');
    pagina.authApi = authApi;
    pagina.aoAutenticar = (usuario: UsuarioSessao) => {
      sessionStore.definirUsuario(usuario);
      router.navegar(usuario.deveTrocarSenha ? CAMINHO_TROCAR_SENHA_OBRIGATORIA : CAMINHO_INICIAL);
    };
    return pagina;
  },
};

/**
 * Tela cheia (sem shell), igual ao login — por isso NÃO passa por
 * `paginaAutenticada` (que é justamente quem redireciona para cá). Ainda
 * assim exige sessão (não marcada `publica`): só um usuário já
 * autenticado pode ter `deveTrocarSenha = true` para começar.
 */
const rotaTrocarSenhaObrigatoria: Rota = {
  caminho: CAMINHO_TROCAR_SENHA_OBRIGATORIA,
  renderizar: () => {
    const pagina = document.createElement('erp-trocar-senha-obrigatoria-page');
    pagina.authApi = authApi;
    pagina.aoConcluir = () => {
      const usuario = sessionStore.obterUsuario();
      if (usuario) sessionStore.definirUsuario({ ...usuario, deveTrocarSenha: false });
      router.navegar(CAMINHO_INICIAL);
    };
    return pagina;
  },
};

/**
 * Perfil → dashboard, resolvido pelo `papel` RBAC (fase de finalização):
 * `admin` → Diretor/CEO; `producao` → Técnico; `marketing` → Colaborador;
 * qualquer outro papel (`financeiro`, `suporte`, `parceiros`) continua na
 * página existente (`erp-dashboard-page`), que já cobre bem a visão
 * operacional/financeira (Admin/Financeiro). Sócio Investidor NÃO é um
 * papel RBAC (nenhum dos 6 papéis descreve isso) — tem rota própria
 * (`rotaMinhaParticipacao`), acessível a qualquer usuário autenticado,
 * resolvida pelo PRÓPRIO dado (`/societario/me`), nunca por papel.
 */
const rotaDashboard: Rota = {
  caminho: CAMINHO_INICIAL,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();

      if (usuario?.papel === 'admin') {
        const pagina = document.createElement('erp-dashboard-ceo-page');
        pagina.relatoriosApi = relatoriosApi;
        pagina.societarioApi = societarioApi;
        pagina.comissoesApi = comissoesApi;
        pagina.financeiroApi = financeiroApi;
        pagina.parceirosApi = parceirosApi;
        pagina.clientesApi = clientesApi;
        pagina.dashboardApi = dashboardApi;
        pagina.usuariosApi = usuariosApi;
        pagina.pedidosApi = pedidosApi;
        pagina.nomeUsuario = usuario.nome;
        return pagina;
      }

      if (usuario?.papel === 'producao') {
        const pagina = document.createElement('erp-dashboard-tecnico-page');
        pagina.opsApi = opsApi;
        pagina.comissoesApi = comissoesApi;
        pagina.societarioApi = societarioApi;
        pagina.usuarioId = usuario.id;
        pagina.nomeUsuario = usuario.nome;
        return pagina;
      }

      if (usuario?.papel === 'marketing') {
        const pagina = document.createElement('erp-dashboard-colaborador-page');
        pagina.comissoesApi = comissoesApi;
        pagina.relatoriosApi = relatoriosApi;
        pagina.nomeUsuario = usuario.nome;
        return pagina;
      }

      const pagina = document.createElement('erp-dashboard-page');
      pagina.dashboardApi = dashboardApi;
      pagina.relatoriosApi = relatoriosApi;
      pagina.permissoesRelatorios = usuario ? permissoesRelatorios(usuario.papel) : { ler: false };
      pagina.societarioApi = societarioApi;
      pagina.permissoesBonusPg = usuario
        ? permissoesBonusPg(usuario.papel)
        : { ler: false, criar: false, atualizar: false };
      pagina.clientesApi = clientesApi;
      return pagina;
    }),
};

const rotaMinhaParticipacao: Rota = {
  caminho: CAMINHO_MINHA_PARTICIPACAO,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-dashboard-socio-page');
      pagina.societarioApi = societarioApi;
      pagina.nomeUsuario = usuario?.nome ?? '';
      return pagina;
    }),
};

const rotaClientes: Rota = {
  caminho: CAMINHO_CLIENTES,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-clientes-page');
      pagina.permissoes = usuario
        ? permissoesClientes(usuario.papel)
        : { ler: false, criar: false, atualizar: false, excluir: false };
      pagina.clientesApi = clientesApi;
      return pagina;
    }),
};

const rotaPedidos: Rota = {
  caminho: CAMINHO_PEDIDOS,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-pedidos-page');
      pagina.permissoes = usuario
        ? permissoesPedidos(usuario.papel)
        : { ler: false, criar: false, atualizar: false };
      pagina.permissoesRelatorios = usuario ? permissoesRelatorios(usuario.papel) : { ler: false };
      pagina.pedidosApi = pedidosApi;
      pagina.clientesApi = clientesApi;
      pagina.dashboardApi = dashboardApi;
      pagina.relatoriosApi = relatoriosApi;
      pagina.opsApi = opsApi;
      pagina.comissoesApi = comissoesApi;
      pagina.usuariosApi = usuariosApi;
      return pagina;
    }),
};

const rotaFinanceiro: Rota = {
  caminho: CAMINHO_FINANCEIRO,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-financeiro-page');
      pagina.permissoes = usuario ? permissoesFinanceiro(usuario.papel) : { ler: false, criar: false };
      pagina.financeiroApi = financeiroApi;
      return pagina;
    }),
};

const rotaFaturamento: Rota = {
  caminho: CAMINHO_FATURAMENTO,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-faturamento-page');
      pagina.permissoes = usuario ? permissoesFaturamento(usuario.papel) : { ler: false };
      pagina.faturamentoApi = faturamentoApi;
      return pagina;
    }),
};

const rotaCaixaBanco: Rota = {
  caminho: CAMINHO_CAIXA_BANCO,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-caixa-banco-page');
      pagina.permissoes = usuario ? permissoesFaturamento(usuario.papel) : { ler: false };
      pagina.caixaBancoApi = caixaBancoApi;
      return pagina;
    }),
};

const rotaProducao: Rota = {
  caminho: CAMINHO_PRODUCAO,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-producao-page');
      pagina.permissoes = usuario ? permissoesOps(usuario.papel) : { ler: false, atualizar: false };
      pagina.opsApi = opsApi;
      pagina.usuarioAtualId = usuario?.id ?? null;
      return pagina;
    }),
};

const rotaParcerias: Rota = {
  caminho: CAMINHO_PARCERIAS,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-parceiros-page');
      pagina.permissoesParceiros = usuario
        ? permissoesParceiros(usuario.papel)
        : { ler: false, criar: false, atualizar: false };
      pagina.permissoesComissoes = usuario ? permissoesComissoes(usuario.papel) : { ler: false, atualizar: false };
      pagina.parceirosApi = parceirosApi;
      pagina.comissoesApi = comissoesApi;
      pagina.financeiroApi = financeiroApi;
      return pagina;
    }),
};

const rotaEstoque: Rota = {
  caminho: CAMINHO_ESTOQUE,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-estoque-page');
      pagina.permissoes = usuario ? permissoesEstoque(usuario.papel) : { ler: false, criar: false, atualizar: false };
      pagina.estoqueApi = estoqueApi;
      return pagina;
    }),
};

const rotaEnvios: Rota = {
  caminho: CAMINHO_ENVIOS,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-envios-page');
      pagina.permissoes = usuario ? permissoesEnvios(usuario.papel) : { ler: false, atualizar: false };
      pagina.enviosApi = enviosApi;
      return pagina;
    }),
};

const rotaGarantias: Rota = {
  caminho: CAMINHO_GARANTIAS,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-garantias-page');
      pagina.permissoes = usuario ? permissoesGarantias(usuario.papel) : { ler: false, atualizar: false };
      pagina.garantiasApi = garantiasApi;
      return pagina;
    }),
};

const rotaBonusPg: Rota = {
  caminho: CAMINHO_BONUS_PG,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-bonus-pg-page');
      pagina.permissoes = usuario ? permissoesBonusPg(usuario.papel) : { ler: false, criar: false, atualizar: false };
      pagina.societarioApi = societarioApi;
      pagina.usuarioId = usuario?.id ?? null;
      return pagina;
    }),
};

const rotaSuporte: Rota = {
  caminho: CAMINHO_SUPORTE,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-suporte-page');
      pagina.permissoes = usuario ? permissoesSuporte(usuario.papel) : { ler: false, criar: false, atualizar: false };
      pagina.suporteApi = suporteApi;
      pagina.clientesApi = clientesApi;
      return pagina;
    }),
};

const rotaCms: Rota = {
  caminho: CAMINHO_CMS,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-cms-page');
      pagina.permissoes = usuario ? permissoesCms(usuario.papel) : { ler: false, atualizar: false };
      pagina.cmsApi = cmsApi;
      return pagina;
    }),
};

const rotaGaleria: Rota = {
  caminho: CAMINHO_GALERIA,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-galeria-page');
      pagina.permissoes = usuario ? permissoesGaleria(usuario.papel) : { ler: false, criar: false, atualizar: false, excluir: false };
      pagina.galeriaApi = galeriaApi;
      return pagina;
    }),
};

const rotaAutomacoes: Rota = {
  caminho: CAMINHO_AUTOMACOES,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-automacoes-page');
      pagina.permissoes = usuario ? permissoesAutomacoes(usuario.papel) : { ler: false, atualizar: false };
      pagina.automacoesApi = automacoesApi;
      return pagina;
    }),
};

const rotaIntegracoesMelhorEnvio: Rota = {
  caminho: CAMINHO_INTEGRACOES_MELHOR_ENVIO,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-melhor-envio-page');
      pagina.permissoes = usuario ? permissoesIntegracoes(usuario.papel) : { ler: false, gerenciar: false };
      pagina.api = integracoesApi;
      return pagina;
    }),
};

const rotaUsuarios: Rota = {
  caminho: CAMINHO_USUARIOS,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-usuarios-page');
      pagina.permissoes = usuario ? permissoesUsuarios(usuario.papel) : { ler: false, criar: false, atualizar: false };
      pagina.usuariosApi = usuariosApi;
      return pagina;
    }),
};

const rotaEquipe: Rota = {
  caminho: CAMINHO_EQUIPE,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-equipe-page');
      pagina.permissoes = usuario ? permissoesEquipe(usuario.papel) : { ler: false };
      pagina.usuariosApi = usuariosApi;
      pagina.comissoesApi = comissoesApi;
      return pagina;
    }),
};

const rotaPermissoes: Rota = {
  caminho: CAMINHO_PERMISSOES,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-papeis-permissoes-page');
      pagina.permissoes = usuario ? permissoesPapeisPermissoes(usuario.papel) : { ler: false };
      pagina.papeisPermissoesApi = papeisPermissoesApi;
      return pagina;
    }),
};

const rotaAuditoria: Rota = {
  caminho: CAMINHO_AUDITORIA,
  renderizar: () =>
    paginaAutenticada(() => {
      const usuario = sessionStore.obterUsuario();
      const pagina = document.createElement('erp-auditoria-page');
      pagina.permissoes = usuario ? permissoesAuditoria(usuario.papel) : { ler: false };
      pagina.auditoriaApi = auditoriaApi;
      return pagina;
    }),
};

async function aoSairPortalParceiro(): Promise<void> {
  try {
    await portalParceiroApi.logout();
  } catch (erro) {
    logger.erro('falha ao encerrar sessão do parceiro no servidor', { erro });
  } finally {
    portalParceiroSessionStore.definirParceiro(null);
    router.navegar(CAMINHO_PORTAL_PARCEIRO_LOGIN);
  }
}

/**
 * Portal do Parceiro (Decisão do owner — mesma estrutura de
 * Sena/Bichão/Savytzz/Renato Rosk, `DECISIONS.md` DEC-037). Ambas as
 * rotas são `publica: true` porque a guarda de sessão aqui é a do
 * Portal (`portalParceiroSessionStore`), nunca a do ERP interno
 * (`temSessao`/`sessionStore`) — um visitante sem sessão de
 * `identidade.usuarios` deve conseguir acessar o Portal normalmente, e
 * um usuário interno autenticado não ganha acesso ao Portal só por
 * estar logado no ERP (identidades estruturalmente separadas, mesma
 * fronteira do backend). Nenhuma das duas passa por `paginaAutenticada`
 * — o Portal nunca usa `<erp-shell>`/sidebar do ERP interno.
 */
const rotaPortalParceiroLogin: Rota = {
  caminho: CAMINHO_PORTAL_PARCEIRO_LOGIN,
  publica: true,
  renderizar: () => {
    const pagina = document.createElement('erp-portal-parceiro-login-page');
    pagina.portalApi = portalParceiroApi;
    pagina.aoAutenticar = (parceiro) => {
      portalParceiroSessionStore.definirParceiro(parceiro);
      router.navegar(parceiro.deveTrocarSenha ? CAMINHO_PORTAL_PARCEIRO_TROCAR_SENHA : CAMINHO_PORTAL_PARCEIRO);
    };
    return pagina;
  },
};

/**
 * Guarda de troca de senha obrigatória do Portal, mesmo princípio de
 * `paginaAutenticada` (Auth interno) — só que sem `<erp-shell>`, já que
 * o Portal nunca usa o shell do ERP interno.
 */
async function paginaAutenticadaPortalParceiro(
  criarConteudo: (parceiro: NonNullable<ReturnType<typeof portalParceiroSessionStore.obterParceiro>>) => HTMLElement
): Promise<HTMLElement> {
  let parceiro = portalParceiroSessionStore.obterParceiro();
  if (!parceiro) {
    parceiro = await portalParceiroApi.obterParceiroAtual();
    portalParceiroSessionStore.definirParceiro(parceiro);
  }
  if (!parceiro) {
    router.navegar(CAMINHO_PORTAL_PARCEIRO_LOGIN);
    // Substituído pela renderização do login logo em seguida (mesmo
    // ciclo de `agendarRenderizacao`) — nunca fica visível de fato.
    return document.createElement('div');
  }
  if (parceiro.deveTrocarSenha) {
    router.navegar(CAMINHO_PORTAL_PARCEIRO_TROCAR_SENHA);
    return document.createElement('div');
  }
  return criarConteudo(parceiro);
}

const rotaPortalParceiro: Rota = {
  caminho: CAMINHO_PORTAL_PARCEIRO,
  publica: true,
  renderizar: () =>
    paginaAutenticadaPortalParceiro((parceiro) => {
      const pagina = document.createElement('erp-portal-parceiro-page');
      pagina.portalApi = portalParceiroApi;
      pagina.parceiro = parceiro;
      pagina.aoSair = () => void aoSairPortalParceiro();
      return pagina;
    }),
};

const rotaPortalParceiroTrocarSenha: Rota = {
  caminho: CAMINHO_PORTAL_PARCEIRO_TROCAR_SENHA,
  publica: true,
  renderizar: async () => {
    let parceiro = portalParceiroSessionStore.obterParceiro();
    if (!parceiro) {
      parceiro = await portalParceiroApi.obterParceiroAtual();
      portalParceiroSessionStore.definirParceiro(parceiro);
    }
    if (!parceiro) {
      router.navegar(CAMINHO_PORTAL_PARCEIRO_LOGIN);
      return document.createElement('div');
    }
    if (!parceiro.deveTrocarSenha) {
      router.navegar(CAMINHO_PORTAL_PARCEIRO);
      return document.createElement('div');
    }
    const pagina = document.createElement('erp-portal-trocar-senha-obrigatoria-page');
    pagina.portalApi = portalParceiroApi;
    pagina.aoConcluir = () => {
      portalParceiroSessionStore.definirParceiro({ ...parceiro!, deveTrocarSenha: false });
      router.navegar(CAMINHO_PORTAL_PARCEIRO);
    };
    return pagina;
  },
};

async function aoSairPortalCliente(): Promise<void> {
  try {
    await portalClienteApi.logout();
  } catch (erro) {
    logger.erro('falha ao encerrar sessão do cliente no servidor', { erro });
  } finally {
    portalClienteSessionStore.definirCliente(null);
    router.navegar(CAMINHO_PORTAL_CLIENTE_LOGIN);
  }
}

/**
 * Portal do Cliente — mesma estrutura do Portal do Parceiro acima.
 * Ambas as rotas são `publica: true` porque a guarda de sessão aqui é a
 * do Portal (`portalClienteSessionStore`), nunca a do ERP interno
 * (`temSessao`/`sessionStore`) nem a do Portal do Parceiro — um
 * visitante sem sessão de `identidade.usuarios` deve conseguir acessar
 * o Portal do Cliente normalmente, e um usuário interno/parceiro
 * autenticado não ganha acesso ao Portal do Cliente só por estar logado
 * em outro contexto (identidades estruturalmente separadas, mesma
 * fronteira do backend). Nenhuma das duas passa por `paginaAutenticada`
 * — o Portal nunca usa `<erp-shell>`/sidebar do ERP interno.
 */
const rotaPortalClienteLogin: Rota = {
  caminho: CAMINHO_PORTAL_CLIENTE_LOGIN,
  publica: true,
  renderizar: () => {
    const pagina = document.createElement('erp-portal-cliente-login-page');
    pagina.portalApi = portalClienteApi;
    pagina.aoAutenticar = (cliente) => {
      portalClienteSessionStore.definirCliente(cliente);
      router.navegar(CAMINHO_PORTAL_CLIENTE);
    };
    return pagina;
  },
};

const rotaPortalCliente: Rota = {
  caminho: CAMINHO_PORTAL_CLIENTE,
  publica: true,
  renderizar: async () => {
    let cliente = portalClienteSessionStore.obterCliente();
    if (!cliente) {
      cliente = await portalClienteApi.obterClienteAtual();
      portalClienteSessionStore.definirCliente(cliente);
    }
    if (!cliente) {
      router.navegar(CAMINHO_PORTAL_CLIENTE_LOGIN);
      // Substituído pela renderização do login logo em seguida (mesmo
      // ciclo de `agendarRenderizacao`) — nunca fica visível de fato.
      return document.createElement('div');
    }
    const pagina = document.createElement('erp-portal-cliente-page');
    pagina.portalApi = portalClienteApi;
    pagina.cliente = cliente;
    pagina.aoSair = () => void aoSairPortalCliente();
    return pagina;
  },
};

/** Todo módulo listado na navegação (`navegacao.ts`) que ainda não tem página real cai aqui — nunca em uma rota ausente/404. */
const CAMINHOS_COM_PAGINA_REAL = new Set([
  CAMINHO_INICIAL,
  CAMINHO_MINHA_PARTICIPACAO,
  CAMINHO_CLIENTES,
  CAMINHO_PEDIDOS,
  CAMINHO_FINANCEIRO,
  CAMINHO_FATURAMENTO,
  CAMINHO_CAIXA_BANCO,
  CAMINHO_PRODUCAO,
  CAMINHO_PARCERIAS,
  CAMINHO_ESTOQUE,
  CAMINHO_ENVIOS,
  CAMINHO_GARANTIAS,
  CAMINHO_BONUS_PG,
  CAMINHO_SUPORTE,
  CAMINHO_CMS,
  CAMINHO_GALERIA,
  CAMINHO_AUTOMACOES,
  CAMINHO_INTEGRACOES_MELHOR_ENVIO,
  CAMINHO_EQUIPE,
  CAMINHO_USUARIOS,
  CAMINHO_PERMISSOES,
  CAMINHO_AUDITORIA,
]);
const rotasModulosFuturos: Rota[] = GRUPOS_NAVEGACAO.flatMap((grupo) => grupo.itens)
  .filter((item) => !CAMINHOS_COM_PAGINA_REAL.has(item.caminho))
  .map((item) => ({
    caminho: item.caminho,
    renderizar: () => paginaAutenticada(() => criarPaginaModuloIndisponivel(item.rotulo)),
  }));

const router = new Router({
  rotas: [
    rotaLogin,
    rotaTrocarSenhaObrigatoria,
    rotaDashboard,
    rotaMinhaParticipacao,
    rotaClientes,
    rotaPedidos,
    rotaFinanceiro,
    rotaFaturamento,
    rotaCaixaBanco,
    rotaProducao,
    rotaParcerias,
    rotaEstoque,
    rotaEnvios,
    rotaGarantias,
    rotaBonusPg,
    rotaSuporte,
    rotaCms,
    rotaGaleria,
    rotaAutomacoes,
    rotaIntegracoesMelhorEnvio,
    rotaEquipe,
    rotaUsuarios,
    rotaPermissoes,
    rotaAuditoria,
    rotaPortalParceiroLogin,
    rotaPortalParceiro,
    rotaPortalParceiroTrocarSenha,
    rotaPortalClienteLogin,
    rotaPortalCliente,
    ...rotasModulosFuturos,
  ],
  outlet: appEl,
  caminhoLogin: CAMINHO_LOGIN,
  caminhoInicial: CAMINHO_INICIAL,
  temSessao: () => sessionStore.estaAutenticado(),
  renderizarNaoEncontrada: () => paginaAutenticada(() => criarPaginaNaoEncontrada()),
  aoRenderizar: (rota) => {
    shell.sidebar.ativo = rota.caminho;
    shell.header.titulo = tituloDaRota(rota.caminho);
  },
});

/**
 * Command Palette (Cmd+K/Ctrl+K) — `BACKLOG.md`, Módulo 14, Alta
 * prioridade. Itens = a mesma navegação real do menu lateral
 * (`GRUPOS_NAVEGACAO`), nunca uma lista inventada à parte — inclui
 * também módulos ainda sem página própria (cai no mesmo fallback
 * "módulo indisponível" que o menu lateral já usa, nunca escondido).
 * Anexado a `document.body` (fora do shell) para funcionar independente
 * de qual página está montada; só abre quando autenticado.
 */
const commandPalette = document.createElement('pg-command-palette');
document.body.appendChild(commandPalette);
commandPalette.items = GRUPOS_NAVEGACAO.flatMap((grupo) =>
  grupo.itens.map((item) => ({ value: item.caminho, label: item.rotulo, grupo: grupo.titulo ?? 'Navegação' }))
);
commandPalette.addEventListener('pg-select', (evento) => {
  const { value } = (evento as CustomEvent<{ value: string }>).detail;
  commandPalette.removeAttribute('open');
  router.navegar(value);
});
commandPalette.addEventListener('pg-close', () => commandPalette.removeAttribute('open'));
document.addEventListener('keydown', (evento) => {
  if (!(evento.metaKey || evento.ctrlKey) || evento.key.toLowerCase() !== 'k') return;
  if (!sessionStore.estaAutenticado()) return;
  evento.preventDefault();
  commandPalette.setAttribute('open', '');
});
// A "busca" do header é o mesmo Command Palette acima, não um endpoint de
// busca à parte (nenhum existe) — clicar nela só abre a mesma paleta que
// Cmd+K já abre.
shell.header.addEventListener('erp-abrir-busca', () => commandPalette.setAttribute('open', ''));

sessionStore.inscrever((usuario) => {
  shell.header.usuario = usuario;
  void atualizarNotificacoes();
});

async function bootstrap(): Promise<void> {
  // `obterUsuarioAtual()` só devolve `null` para 401 (sem sessão) — para
  // qualquer OUTRA falha (ex: 500 por banco inacessível, erro de rede),
  // ela relança. Sem este catch, essa rejeição impedia `router.iniciar()`
  // de rodar e a aplicação inteira ficava com `#app` vazio para sempre,
  // em vez de cair na tela de login (mesma postura fail-closed: sessão
  // incerta é tratada como "não autenticado", nunca como autenticado).
  let usuario: UsuarioSessao | null = null;
  try {
    usuario = await authApi.obterUsuarioAtual();
  } catch (erro) {
    logger.erro('falha ao verificar sessão atual — tratando como não autenticado', { erro });
  }
  sessionStore.definirUsuario(usuario);
  router.iniciar();
  setInterval(() => void atualizarNotificacoes(), INTERVALO_ATUALIZACAO_NOTIFICACOES_MS);
}

void bootstrap();
